import React from 'react';
import { Picker, Icon, List, DatePicker } from 'antd-mobile';
import {
  FormItem,
  IComponentPicker,
  IComponentDatePicker,
  isIComponentPicker,
  isIComponentDatePicker,
  IComponentInput,
  isIComponentInput,
} from './type';
import './index.css';

export function renderItem(item: FormItem) {
  if (!!isIComponentPicker(item)) {
    return <RenderPicker {...item} />
  }
  if (!!isIComponentDatePicker(item)) {
    return <RenderDatePicker {...item} />
  }
  if (!!isIComponentInput(item)) {
    return <RenderInput {...item} />
  }
  return <div />
}

/**
 * @param children 组件
 * @title 标题
 *
 * @interface ComponentContainerProps
 */
interface ComponentContainerProps {
  children: any;
  title?: string;
}

/**
 * 渲染formitem组件的通用父层
 *
 * @export
 * @param {ComponentContainerProps} props
 */
export function ComponentContainer(props: ComponentContainerProps) {
  const { title } = props;
  return (
    <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column' }}>
      {title && <div className='component-title'>{title}</div>}
      {props.children}
    </div>
  )
}

interface ComponentContentProps {
  // title: string;
  onClick?: any;
  extra?: string;
  children?: any;
  disabled?: boolean;
  style?: any;
}

/**
 * 渲染item内容
 *
 * @export
 * @param {ComponentContentProps} props
 * @returns
 */
export function ComponentContent(props: ComponentContentProps) {
  const isPlaceHolder = props.extra === '请选择' || props.extra?.indexOf('请选择') !== -1;
  const isDisable = !!props.disabled;
  return (
    <div className='component-content' style={{ ...props.style, backgroundColor: isDisable ? 'rgba(0, 0, 0, 0.1)' : '' }} onClick={props.onClick}>
      {props.extra && <span style={{ color: isPlaceHolder ? 'rgba(0, 0, 0, 0.4)' : 'black' }} >{props.extra}</span>}
      {props.extra && <Icon type='down' />}
      {props.children}
    </div>
  )
}

export function RenderInput(props: IComponentInput) {
  const { formTitle, disabled, ...rest } = props;
  return (
    <ComponentContent disabled={disabled}>
      <input className="component-input" disabled={disabled} {...rest} />
    </ComponentContent>
  );
}

export function RenderPicker(props: IComponentPicker) {
  const { formTitle, data, placeholder, value, disabled, style, ...rest } = props;
  return (
    <Picker {...rest} disabled={disabled} value={value} data={data || []}>
      <ComponentContent disabled={disabled} style={style} />
    </Picker>
  );
}

export function RenderDatePicker(props: IComponentDatePicker) {
  const { formTitle, value, disabled, ...rest } = props;
  return (
    <DatePicker {...rest} value={value} disabled={disabled}>
      <ComponentContent disabled={disabled} />
    </DatePicker>
  );
}
